import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminTools = lazy(() => import("@/pages/admin/AdminTools"));

export const Route = createFileRoute("/admin/verktyg")({
  component: () => <AdminTools />,
});
